import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CoursesNavbar() {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (className) => {
    setOpenDropdown(openDropdown === className ? null : className);
  };

  const classes = [
    { name: "Class 8", slug: "class-8", subjects: ["Computer Science", "Math", "Science"] },
    { name: "Class 9", slug: "class-9", subjects: ["Computer Science", "Math", "Science"] },
    { name: "Class 10", slug: "class-10", subjects: ["Computer Science", "Math", "Physics"] },
    { name: "Class 11", slug: "class-11", subjects: ["Computer Science", "Math", "Physics"] },
    { name: "Class 12", slug: "class-12", subjects: ["Computer Science", "Math", "Physics"] },
  ];

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:justify-center md:space-x-6">

          {classes.map((cls) => (
            <div key={cls.name} className="relative w-full md:w-auto">

              {/* Class button */}
              <button
                onClick={() => toggleDropdown(cls.name)}
                className="w-full md:w-auto px-4 py-2 text-white md:text-black md:bg-transparent bg-blue-600 font-bold text-center hover:bg-blue-700 md:hover:bg-gray-100 rounded md:rounded-none mb-2 md:mb-0"
              >
                {cls.name}
              </button>

              {/* Dropdown */}
              {openDropdown === cls.name && (
                <div className="bg-white text-black rounded shadow-md mt-1 md:absolute md:top-full md:left-0 min-w-[200px] z-50">
                  {cls.subjects.map((subj) => {
                    const subjectSlug = subj.toLowerCase().replace(/\s+/g, "-");
                    const url = `/enotes-${cls.slug}/enotes-${cls.slug}-${subjectSlug}`;

                    return (
                      <Link
                        key={subj}
                        to={url}
                        className="block px-4 py-2 hover:bg-yellow-200 font-normal"
                        onClick={() => setOpenDropdown(null)}
                      >
                        {subj}
                      </Link>
                    );
                  })}
                </div>
              )}

            </div>
          ))}

        </div>
      </div>
    </nav>
  );
}
